module.exports = __webpack_public_path__ + "static/media/tcw.60babf15.md";